import React, { useState } from 'react'

const initial = {
  token: null,
  chatServiceUrl: null,
  setToken: () => { },
  setChatURL: () => { }
}

/**
 * @typedef {Object} WelcomePacket
 * @property {string} chat_size
 * @property {string} primary_color
 * @property {string} contrast_color
 * @property {string} button_color
 * @property {string} send_type
 * @property {string} agent_name
 * @property {string} agent_avatar
 * @property {string} bot_name
 * @property {number} fallback_timer
 * @property {string} prompt_visibility
 * @property {number} prompt_icon_id
 * @property {string} prompt_icon_url
 * @property {number} bot_participant_id
 * @property {number} default_bot_profile_id
 * @property {boolean} online
 * @property {boolean} disable_new_conversation
 * @property {boolean} branding
 * @property {Object} agent_social_profiles
 */

/**
 * @typedef {Object} SessionContextValue
 * @property {WelcomePacket} welcomePacket
 * @property {string} token
 * @property {function(string): void} setToken
 * @property {number} activeConversationId
 * @property {function(number): void} setActiveConversationId
 * @property {string} chatServiceUrl
 * @property {function(string): void} setChatURL
 * @property {function(WelcomePacket): void} setWelcomePacket
 */

/** @type {React.Context<SessionContextValue>} */
const SessionContext = React.createContext(initial)
function SessionProvider (props) {
  const [chatServiceUrl, setChatURL] = useState(null)
  const [token, setToken] = useState(null)
  const [activeConversationId, setActiveConversationId] = useState(null)
  const [welcomePacket, setWelcomePacket] = useState(null)
  return (
    <SessionContext.Provider value={{
      token,
      setToken,
      activeConversationId,
      setActiveConversationId,
      chatServiceUrl,
      setChatURL,
      welcomePacket,
      setWelcomePacket
    }}
    >
      {props.children}
    </SessionContext.Provider>
  )
}

export { SessionContext, SessionProvider }
